import { Grid, makeStyles, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import NumberFormat from "react-number-format";
import InputMask from "react-input-mask";
import styles from "../../../styles/global-styles";
import { getTotalCostByUnits } from "./utils-shoppingCart";
import DeleteProductFromCart from "../modals/DeleteProductFromCart";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import { actions as shoppingCartActions } from "../../../redux/actions/shoppingCart";
import { ProductService } from "../../../services/product.service";
import { BalanceTransferService } from "../../../services/balanceTransfer.service";
import { CashCardService } from "../../../services/cashCard.service";

const useStyles = makeStyles((theme) => ({
  body: styles.body,
  deleteLink: styles.deleteLink,
  box: {
    marginTop: 10,
    // border: "2px solid red",
    width: "25%",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "100%",
      border: "0.2px solid #f2f2f2",
      fontSize: 18,
    },
    "& .MuiInputAdornment-root p": {
      color: "rgba(5, 5, 5, 0.73)",
      fontSize: 20,
      fontWeight: 700,
    },
  },
  porcentageLabel: {
    fontWeight: 800,
    color: "#1C2668",
    opacity: 0.6,
    fontSize: 16,
    padding: 10,
  },
}));

const InfoProductsShoppingCart = ({
  addAlert,
  detailAlert,
  counterProductsArray,
  productTypeId,
  removeItemFromCart,
  updateItem,
  shoppingCart: { cart },
}) => {
  const classes = useStyles();

  /**TODO cargar discount en caso de ya existir
   * uno en el reducer de cart
   */
  const [percentageObject, setPercentageObject] = useState({});
  const [productsArray, setProductsArray] = useState(counterProductsArray);
  const [openModal, setOpenModal] = useState({});

  useEffect(() => {
    /** JSON.stringify works for listen
     * any change on objectsArray -> counterProductsArray
     * */
    setProductsArray(counterProductsArray);
  }, [JSON.stringify(counterProductsArray)]);

  const handleInputText = ({ target: { value } }, cashCardInfo) => {
    setPercentageObject({ ...percentageObject, [cashCardInfo]: value });
  };

  const handlePercentage = async (item) => {
    let finalPrice = "";
    let discount = 0;
    Object.entries(percentageObject).forEach(([key, value]) => {
      if (item.productInfo === key) {
        const totalPrice = item.units * item.price;
        discount = (totalPrice * value) / 100;
        finalPrice = totalPrice - discount;
      }
    });

    /** Balance transfer product */
    if (item.productTypeId === "5") {
      const id = Object.values(cart)[0].balanceTransferId;
      const { data } = await BalanceTransferService.updateBalanceTransfer(
        { discount },
        id
      );
      if (data.length === 1) {
        updateItem({
          value: discount,
          key: Object.keys(cart)[0],
          type: "balanceTransfer",
        });
      }
    }

    /** Cash card product */
    if (item.productTypeId === "4") {
      const filterCart = Object.values(cart).filter((product) => {
        if (product.cash_card) {
          return product.cash_card?.card_catalogue?.barCode === item.barCode;
        }
      });
      const cashCardIds = filterCart.map((value) => value.cashCardId);
      console.log("cashCardIds", cashCardIds);
      const result = counterProductsArray.filter((prod) => {
        if (prod.barCode === item.barCode) {
          return prod;
        }
      });
      const discountPerProduct = discount / result[0].units;
      const { data } = await CashCardService.updateDiscountCashCardBulk(
        cashCardIds,
        discountPerProduct
      );
      console.log("cash carrd updated", data);
      if (data.length >= 1) {
        filterCart.forEach((item) => {
          updateItem({
            value: discountPerProduct,
            key: item.id,
            type: "cashCard",
          });
        });
      }
    }

    const copyArray = [...productsArray];
    productsArray.forEach((product, i) => {
      if (product.productInfo === item.productInfo)
        copyArray[i] = {
          ...copyArray[i],
          priceWithDiscount: finalPrice,
          discount,
        };
    });
    setProductsArray(copyArray);
  };

  const handleOnCloseModal = () => {
    setOpenModal({ ...openModal, open: false, product: null });
  };

  const handleDeleteProduct = async (item) => {
    if (
      productTypeId === "1" ||
      productTypeId === "2" ||
      productTypeId === "4"
    ) {
      setOpenModal({ ...openModal, open: true, product: item });
    } else if (productTypeId === "5") {
      const productId = Object.keys(cart)[0];
      const balanceTransferId = Object.values(cart)[0].balance_transfer.id;
      console.log("productId", productId);
      console.log("balanceTransferId", balanceTransferId);
      try {
        const { data } = await ProductService.deleteProduct(productId);
        if (data === 1) removeItemFromCart({ item: Object.values(cart)[0] });
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    } else if (productTypeId === "6") {
      const phonePlanArray = Object.values(cart).filter(
        (value) => value.phone_plan !== null
      );
      const itemToDelete = phonePlanArray.filter(
        (product) => product.phonePlanId === parseInt(item.id)
      );
      console.log("itemToDelete", itemToDelete);
      console.log("item in param", item);
      try {
        const { data, status } = await ProductService.deleteProduct(
          itemToDelete[0].id
        );
        if (data === 1) removeItemFromCart({ item: itemToDelete[0] });
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    }
  };

  if (productsArray.length)
    return (
      <>
        {productsArray
          .filter((item) => item.productTypeId === productTypeId)
          .map((item, i) => (
            <Fragment key={i}>
              <Grid container direction="row" justify="space-around">
                <Grid item>
                  <Typography variant="body2" className={classes.body}>
                    X {item.units}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2" component={"span"}>
                    {item.productInfo}
                  </Typography>
                </Grid>
                <Grid item>
                  <NumberFormat
                    value={item.price}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </Grid>
                <Grid item style={{ fontWeight: 800, fontSize: 16 }}>
                  <NumberFormat
                    value={
                      // item.priceWithDiscount ||
                      getTotalCostByUnits(item.units, item.price)
                    }
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </Grid>
                <Grid item>
                  <span
                    className={classes.deleteLink}
                    onClick={() => handleDeleteProduct(item)}
                  >
                    Eliminar
                  </span>
                </Grid>
              </Grid>

              {(productTypeId === "4" || productTypeId === "5") && (
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  justify="flex-start"
                  alignItems="center"
                  style={{ marginBottom: 16, marginLeft: 10 }}
                >
                  <Grid item>
                    <span className={classes.porcentageLabel}>Descuento</span>
                  </Grid>
                  <Grid item className={classes.box}>
                    <InputMask
                      mask="999"
                      inputProps={{
                        maxLength: 10,
                      }}
                      maskChar=""
                      value={item.cashCardInfo}
                      onChange={(e) => handleInputText(e, item.productInfo)}
                      onBlur={() => handlePercentage(item)}
                    >
                      {() => (
                        <TextField
                          name="discount"
                          className={classes.textField}
                          variant="outlined"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    </InputMask>
                  </Grid>
                  {item.discount != null && item.discount !== 0 && (
                    <Grid item>
                      <span
                        className={classes.porcentageLabel}
                        style={{ marginLeft: 10 }}
                      >
                        ${item.discount}
                      </span>
                    </Grid>
                  )}
                </Grid>
              )}
            </Fragment>
          ))}

        {openModal.open && (
          <DeleteProductFromCart
            open={openModal.open}
            onClose={handleOnCloseModal}
            product={openModal.product}
            productsArray={productsArray}
          />
        )}
      </>
    );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
  removeItemFromCart: shoppingCartActions.removeItemFromCart,
  updateItem: shoppingCartActions.updateItem,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(InfoProductsShoppingCart);
